/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import StyledDrawerMenuLogoContainer from 'common/theme/drawer-menu/StyledDrawerMenuLogoContainer';
import StyledDrawerMenuLogotypeContainer from 'common/theme/drawer-menu/StyledDrawerMenuLogotypeContainer';
import { ReactComponent as Logotype } from 'images/logotype.svg';
import { ReactComponent as Logo } from 'images/logo.svg';
import routes from 'common/routes';
import { isAdmin, isSupervisor, isTrainer } from 'common/utils/user';
import SidebarPanelContext from 'context/SidebarPanelContext';

function DrawerLogo() {
  const navigate = useNavigate();
  // iconOnly viene del panel host (desktop colapsado); el drawer mobile siempre expandido.
  const { iconOnly: miniDrawer } = useContext(SidebarPanelContext);
  const role = useSelector((state) => state.auth.user?.role);

  // Inicio según rol (mismo destino que el ítem "Inicio" del menú).
  let homePath = routes.clientDashboard.path;
  if (isAdmin(role) || isSupervisor(role)) homePath = routes.adminDashboard.path;
  else if (isTrainer(role)) homePath = routes.trainerDashboard.path;

  const inner = miniDrawer ? (
    <StyledDrawerMenuLogoContainer>
      <Logo />
    </StyledDrawerMenuLogoContainer>
  ) : (
    <StyledDrawerMenuLogotypeContainer>
      <Logotype />
    </StyledDrawerMenuLogotypeContainer>
  );

  return (
    <Box
      onClick={() => navigate(homePath)}
      role="button"
      tabIndex={0}
      aria-label="Inicio"
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(homePath); }}
      sx={{ cursor: 'pointer' }}>
      {inner}
    </Box>
  );
}

export default DrawerLogo;
